import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { ProblemDetails } from './generated';
import { SerializedError } from '@reduxjs/toolkit';

export const handleResponse = <TData>(
  response: { data?: TData; error?: SerializedError | FetchBaseQueryError },
  errorHandler: (error: ProblemDetails) => void,
  successHandler?: (data?: TData) => void,
) => {
  if (response.error) {
    // no problem details in error, skip
    if (!response.error || !('data' in response.error)) {
      console.warn('No data in error', response);
      return;
    }

    const problemDetails = response.error.data as ProblemDetails;
    if (!problemDetails) {
      console.warn('No problem details in error', response);
      return;
    }

    errorHandler(problemDetails);
    return;
  }

  // data in response, call success handler
  successHandler?.(response.data);
};
